import React, {
  useContext,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import "./SpecifyTab.scss";
import { columnsSpecifyList2 } from "./specifyTab.config";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Space,
  Table,
  Tooltip,
  Typography,
  notification,
} from "antd";
import { ModalCustom, Notification } from "components/common";
import ModalSpecify from "./ModalSpecify/ModalSpecify";
import Icons from "assets/icons";
import { examinationService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { ListActionButton } from "components/common";
import { EXAM_BTN_CLICK_TYPE } from "types/enums/examination";
import dayjs from "dayjs";
import { setListAssign } from "redux/reducer/listAssign";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import { parseDatetime } from "helper/format-date";
import { SuccessSVG } from "assets";
import {
  formatDateToStringTimezone_7,
  formatToCurrencyType,
} from "helper/common";
import {
  trangThaiOptions,
  trangThaiTTOptions,
} from "assets/constants/kbnt-category";
import PhieuChiDinh from "./PhieuChiDinh/PhieuChiDinh";
import PhieuChiDinh2 from "./PhieuChiDinh2/PhieuChiDinh2";
import { ColumnsEdit } from "types/models/column-table-edit";
import e from "cors";
import { FORMAT_TIME } from "types/enums";
import AlertModal from "components/common/AlertModal/AlertModal";

const catalogNDV = {
  xetNghiem: ["Huyết học", "Sinh hóa", "Vi sinh", "Nước tiểu"],
  CDHA: ["Chẩn đoán hình ảnh", "Khám bệnh", "Thăm dò chức năng"],
  dienTim: ["Điện tim"],
  PTTT: ["Phẫu thuật", "Thủ thuật", "Giường bệnh"],
};

export const SpecifyTab = React.forwardRef((props: any, ref) => {
  const actionStatus = useAppSelector((state) => state.examClick);
  //
  const refModal = useRef<any>();
  const listAssign = useAppSelector((state) => state.listAssign);
  const dataPhieu = useAppSelector((state) => state.examination.dataPhieu);
  //
  const idPKNT = useAppSelector((state) => state.examination.idPKNT);
  const [isShowModal, setIsShowModal] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [loadingTable, setLoadingTable] = useState(true);
  const [totalPageList, setTotalPageList] = useState();
  const [currentPageList, setCurrentPageList] = useState(1);
  const [searchValueList, setSearchValueList] = useState("");
  const dispatch = useAppDispatch();
  const action = useAppSelector((state) => state.listAssign.dsChiDinh);
  // console.log("🚀 ~ SpecifyTab ~ action:", action)
  const [dataSource, setDataSource] = useState<any>(null);
  const [form] = Form.useForm();
  const cDRef = useRef<any>();
  const pCDRef = useRef<any>();
  const pCDRef2 = useRef<any>();

  useImperativeHandle(ref, () => ({
    handleSave: handleSave,
  }));
  const handleSave = async () => {
    await onSavePCD();
  };

  // const mapNumber = (data) => {
  //   if (!data) return [];
  //   let tmp = [];
  //   data.map((it) => {
  //     let tmp2 = Array.from({ length: it.soLuong }, () => ({ ...it }));
  //     tmp = [...tmp, ...tmp2];
  //   });
  //   return tmp;
  // };

  // useMemo(() => {
  //   const newAction = action.map((e) => ({
  //     ...e,
  //     key: e.id,
  //   }));
  //   setDataSource(newAction);
  // }, [action]);

  const [actionData, setActionData] = useState([]);
  const columnsSpecifyList: ColumnsEdit = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      render: (text, record, index) => index + 1,
      align: "center",
      width: 60,
    },
    {
      title: "Mã Dịch vụ",
      dataIndex: "id",
      key: "id",
      align: "left",
      width: 100,
    },
    {
      title: "Tên dịch vụ",
      dataIndex: "tenDichVu",
      key: "tenDichVu",
      align: "left",
    },
    {
      title: "Đơn giá",
      dataIndex: "donGia",
      key: "donGia",
      align: "right",
      render(value, record, index) {
        return <>{formatToCurrencyType(value)}</>;
      },
      width: 140,
    },
    {
      title: "Đơn giá BHYT",
      dataIndex: "bhChiTra",
      key: "bhChiTra",
      align: "right",
      render(value, record, index) {
        return <>{formatToCurrencyType(value)}</>;
      },
      width: 140,
    },
    {
      title: "Ngày chỉ định",
      dataIndex: "ngayChiDinh",
      key: "ngayChiDinh",

      render: (v, r, i) => dayjs(v).format("hh:mm DD/MM/YYYY"),
    },
    {
      title: "Tư vấn",
      dataIndex: "canTuVan",
      key: "canTuVan",
      render: (tv) => {
        if (tv) return <SuccessSVG />;
      },
      width: 80,
    },
    {
      title: "Trạng thái TT",
      dataIndex: "trangThaiThanhToan",
      render: (v, r, i) =>
        trangThaiTTOptions.find((it) => it.value === v)?.label || "",
    },
    {
      title: "Trạng thái HĐ",
      dataIndex: "trangThai",
      render: (v, r, i) =>
        trangThaiOptions.find((it) => it.value === v)?.label || "",
    },
    {
      title: "Số lượng",
      dataIndex: "soLuong",
      align: "right",
      width: 80,
    },
    {
      title: "Ghi chú",
      dataIndex: "ghiChu",
      key: "ghiChu",
      editable: true,
      type: "INPUT",
      ellipsis: true,
      rules: [{ required: true, message: "Chưa nhập ghi chú" }],
    },
    {
      title: "",
      key: "xoa",
      dataIndex: "xoa",
      width: 100,
      render: (v, r: any, i) => {
        const handleDelete = () => {
          // const tmp = listAssign.dsChiDinh.filter((it) => it.id !== r.id);
          // console.log("🚀 ~ handleDelete ~ tmp:", tmp);
          // const temp = dataSource.filter((it) => it.id !== r.id);
          // console.log("🚀 ~ handleDelete ~ temp:", temp);
          // const newData = dataSource?.map((data) => {
          //   const temp = listAssign?.dsChiDinh?.find((e) => {
          //     if (e.id === data.id) {
          //       return {
          //         ...e,
          //         ghiChu: data.ghiChu,
          //       };
          //     }
          //   });
          //   return data;
          // });
          // setDataSource(temp);
          dispatch(
            setListAssign(listAssign.dsChiDinh.filter((it) => it.id != r.id))
          );
          // dispatch(setListAssign(temp));
          // if (tmp.soLuong > 1) {
          //   dispatch(
          //     setListAssign([
          //       ...listAssign.dsChiDinh.filter((it) => it.id != r.id),
          //       { ...tmp, soLuong: tmp.soLuong - 1 },
          //     ])
          //   );
          // } else {
          // dispatch(
          //   setListAssign([
          //     ...temp.map((item) =>
          //       listAssign.dsChiDinh
          //         .filter((it) => it.id != r.id)
          //         .map((e) => ({
          //           ...e,
          //           ghiChu: item.ghiChu,
          //         }))
          //     ),
          //   ])
          // );
          // }
        };
        return (
          <Button
            icon={<Icons.remove />}
            onClick={handleDelete}
            danger
          ></Button>
        );
      },
    },
  ];

  const fetchData = async () => {
    if (idPKNT == null) {
      // notification.error({message: "Chưa có thông tin phiếu khám!"});
      return;
    }
    try {
      setLoadingTable(true);
      const response = await examinationService.getSpecifyTicket({
        idPhieuKhamNgoaiTru: idPKNT,
        page: 1,
        limit: 100,
      });
      setActionData(response.data.data);
      setLoadingTable(false);
    } catch (err) {
      setLoadingTable(false);
      // notification.error({message: "Lỗi khi lấy danh sách dịch vụ"});
    }
  };

  const handlePaginationChangeList = (page) => {
    setCurrentPageList(page);
  };

  const paginationConfigList = {
    current: currentPageList,
    total: totalPageList,
    onChange: handlePaginationChangeList,
  };

  // const valueSearchList =
  //   dataList &&
  //   dataList?.filter((record) =>
  //     columnsSpecifyList2.some((column) =>
  //       record[column.key]
  //         ?.toString()
  //         ?.toLowerCase()
  //         ?.includes(searchValueList.toLowerCase())
  //     )
  //   );

  const handleRowClick = (record) => {
    // setSelectedRecord(record);
    // showModal();
    cDRef.current?.setRecord({ ...record });
    cDRef.current?.openModal();
  };

  const rowProps = (record) => {
    return {
      onDoubleClick: () => handleRowClick(record),
    };
  };

  columnsSpecifyList.map((e) => {
    if (e.key == "action") {
      e.render = (_, record, index) => {
        return (
          <ListActionButton
            addFunction={() => handleOnAdd(record)}
            deleteFunction={() => handleOnDelete(record)}
            showDetailFunction={() => handleOnShowDetail(record)}
          ></ListActionButton>
        );
      };
    }
  });

  const handleOnShowDetail = (record) => {};

  const handleOnDelete = async (record) => {
    const newData = actionData.filter((item) => item.id !== record.id);
    setActionData(newData);
  };

  const handleOnAdd = (record) => {};
  const handlePrint = (record) => {
    let xnindex = 0;
    let cdhaindex = 0;
    let dientimindex = 0;
    let ptttindex = 0;
    let xn = [];
    let cdha = [];
    let dientim = [];
    let pttt = [];
    xn = [
      ...xn,
      ...record.nhomChiDinhDtos
        .filter((et) => catalogNDV.xetNghiem.includes(et.tenNhomChiDinh))
        .map((ft) => {
          let idx = xnindex;
          xnindex += ft?.chiDinhDtos?.length;
          return { ...ft, index: idx };
        }),
    ];
    cdha = [
      ...cdha,
      ...record.nhomChiDinhDtos
        .filter((et) => catalogNDV.CDHA.includes(et.tenNhomChiDinh))
        .map((ft) => {
          let idx = cdhaindex;
          cdhaindex += ft?.chiDinhDtos?.length;
          return { ...ft, index: idx };
        }),
    ];
    dientim = [
      ...dientim,
      ...record.nhomChiDinhDtos
        .filter((et) => catalogNDV.dienTim.includes(et.tenNhomChiDinh))
        .map((ft) => {
          let idx = dientimindex;
          dientimindex = dientimindex + ft.chiDinhDtos.length;
          return { ...ft, index: idx };
        }),
    ];
    pttt = [
      ...pttt,
      ...record.nhomChiDinhDtos
        .filter((et) => catalogNDV.PTTT.includes(et.tenNhomChiDinh))
        .map((ft) => {
          let idx = ptttindex;
          ptttindex += ft?.chiDinhDtos?.length;
          return { ...ft, index: idx };
        }),
    ];
    if (xnindex === 0 && cdhaindex === 0 && ptttindex === 0) {
      Notification("info", "Không có chỉ định thuộc danh mục!");
      return;
    }
    pCDRef2.current?.setDsNhomChiDinhXN(xnindex > 0 ? xn : []);
    pCDRef2.current?.setDsNhomChiDinhCDHA(cdhaindex > 0 ? cdha : []);
    pCDRef2.current?.setDsNhomChiDinhDVKT(ptttindex > 0 ? pttt : []);
    pCDRef2.current?.setDsNhomChiDinhDT(dientimindex > 0 ? dientim : []);
    pCDRef2.current?.setThongTinBN({
      ...dataPhieu,
    });

    pCDRef2.current?.openModal();
  };

  const handleRemove = async (record) => {
    try {
      const res = await examinationService.deleteSpecifyTicket(record?.id);
      Notification("success", "Đã xóa phiếu chỉ định");
      handleOnDelete(record);
    } catch (error) {
      if (
        error?.response?.data ==
        "Xóa không thành công do có chỉ định đã được thanh toán"
      ) {
        Notification(
          "warning",
          "Xóa không thành công do có chỉ định đã được thanh toán"
        );
      } else {
        Notification("error", "Đã có lỗi khi xóa phiếu chỉ định");
      }
    }
  };
  columnsSpecifyList2.map((e) => {
    if (e.key == "action") {
      e.render = (_, record, index) => {
        const handleEdit = () => {
          handleRowClick(record);
        };
        return (
          <Space>
            <Tooltip title="Xem chi tiết và chỉnh sửa">
              <Button
                icon={<Icons.edit />}
                onClick={handleEdit}
                type="primary"
              ></Button>
            </Tooltip>
            <Tooltip title="In">
              <Button
                icon={<Icons.printer />}
                type="primary"
                onClick={() => handlePrint(record)}
              ></Button>
            </Tooltip>
            <Tooltip title="Xóa">
              <Button
                icon={<Icons.remove />}
                type="primary"
                onClick={() => {
                  handleRemove(record);
                }}
              ></Button>
            </Tooltip>
          </Space>
        );
      };
    }
  });

  const onValidNote = () => {
    const allValues = dataSource.every((e) => e.ghiChu);

    if (!allValues) {
      refModal.current.openModal();
    } else onSavePCD();
  };

  const onSavePCD = async () => {
    if (dataSource.length === 0) {
      return;
    }

    form.validateFields().then(async (value) => {
      let current = dayjs();
      const data = {
        idPhieuKhamNgoaiTru: idPKNT,
        ngayTaoPhieu: current.format("YYYY-MM-DDTHH:mm:ss"),
        bacSyChiDinh: props.bacSyKham,
        chiDinhDtos: dataSource.map((it) => ({
          id: 0,
          idPhieuchiDinh: 0,
          tenChiDinh: it.tenDichVu,
          baoHiemTra: it.bhChiTra,
          maDichVu: it.id,
          thoiGian: it.ngayChiDinh.format("YYYY-MM-DDTHH:mm:ss"),
          donGia: it.donGia,
          soLuong: it.soLuong,
          thanhTien: it.soLuong * it.donGia,
          coBaoHiem: it.coBaoHiem,
          bhNgoaiTru: it.bhNgoaiTru,
          bhNoiTru: it.bhNoiTru,
          hienThiBangKe: it.hienThiBangKe,
          canTuVan: it.canTuVan,
          ghiChu: it.ghiChu,
          trangThai: 0,
          trangThaiThanhToan: 0,
        })),
      };
      try {
        await examinationService.saveSpecifyTicket(data);
        Notification("success", "Thêm phiếu chỉ định thành công");
        dispatch(setListAssign([]));
        fetchData();
      } catch (err) {
        Notification("error", "Lỗi khi thêm phiếu chỉ định");
      }
    });
  };
  const onInPCD = async () => {
    if (listAssign.dsChiDinh.length === 0) {
      Notification("warning", "Chưa có chỉ định nào được chọn!");
      return;
    }
    const allValues = dataSource.every((e) => e.ghiChu);

    if (allValues == false) {
      Notification("warning", "Chưa nhập ghi chú");
      return;
    }
    let xnindex = 0;
    let cdhaindex = 0;
    let dientimindex = 0;
    let ptttindex = 0;
    let xn = {
      huyetHoc: [],
      sinhHoa: [],
      viSinh: [],
      nuocTieu: [],
    };
    let cdha = [];
    let dientim = [];
    let pttt = [];
    // console.log(listAssign.dsChiDinh);
    // console.log(dataSource);
    listAssign.dsChiDinh?.map((it) => {
      if (it.idNhomDichVu === 2 || it.idNhomDichVu === 11) {
        pttt = [
          ...pttt,
          {
            ...it,
            ghiChu: dataSource?.find((e) => e?.id == it?.id)?.ghiChu,
          },
        ];
      } else if (it.idNhomDichVu === 7) {
        xnindex += 1;
        let tmp = [
          ...xn.huyetHoc,
          {
            ...it,
            index: xnindex,
            ghiChu: dataSource?.find((e) => e?.id == it?.id)?.ghiChu,
          },
        ];
        xn = { ...xn, huyetHoc: tmp };
      } else if (it.idNhomDichVu === 8) {
        xnindex += 1;
        let tmp = [
          ...xn.sinhHoa,
          {
            ...it,
            index: xnindex,
            ghiChu: dataSource?.find((e) => e?.id == it?.id)?.ghiChu,
          },
        ];
        xn = { ...xn, sinhHoa: tmp };
      } else if (it.idNhomDichVu === 9) {
        xnindex += 1;
        let tmp = [
          ...xn.viSinh,
          {
            ...it,
            index: xnindex,
            ghiChu: dataSource?.find((e) => e?.id == it?.id)?.ghiChu,
          },
        ];
        xn = { ...xn, viSinh: tmp };
      } else if (it.idNhomDichVu === 10) {
        xnindex += 1;
        let tmp = [
          ...xn.nuocTieu,
          {
            ...it,
            index: xnindex,
            ghiChu: dataSource?.find((e) => e?.id == it?.id)?.ghiChu,
          },
        ];
        xn = { ...xn, nuocTieu: tmp };
      } else if (it.idNhomDichVu === 4 || it.idNhomDichVu === 5) {
        cdhaindex += 1;
        cdha = [
          ...cdha,
          { ...it, ghiChu: dataSource?.find((e) => e?.id == it?.id)?.ghiChu },
        ];
      } else if (it.idNhomDichVu === 2 || it.idNhomDichVu === 11) {
        ptttindex += 1;
        pttt = [
          ...pttt,
          { ...it, ghiChu: dataSource?.find((e) => e?.id == it?.id)?.ghiChu },
        ];
      } else if (it.idNhomDichVu === 6) {
        dientimindex += 1;
        dientim = [
          ...dientim,
          { ...it, ghiChu: dataSource?.find((e) => e?.id == it?.id)?.ghiChu },
        ];
      }
    });
    pCDRef.current?.setThongTinBN({ ...dataPhieu });
    if (
      xnindex === 0 &&
      cdha.length === 0 &&
      pttt.length === 0 &&
      dientim.length === 0
    ) {
      Notification("info", "Không có chỉ định thuộc danh mục!");
      return;
    } else {
      pCDRef.current?.setDsNhomChiDinhXN(xnindex > 0 ? xn : null);
      pCDRef.current?.setDsNhomChiDinhCDHA(cdha);
      pCDRef.current?.setDsNhomChiDinhPTTT(pttt);
      pCDRef.current?.setDsNhomChiDinhDT(dientim);
      pCDRef.current?.openModal();
    }
  };

  const onChangeCDRow = async (selectedRowsKey, selectedRows, info) => {};

  // useEffect(() => {
  //   if (actionStatus.actionType === EXAM_BTN_CLICK_TYPE.SAVE) {
  //   }
  // }, [actionStatus]);

  useEffect(() => {
    fetchData();
  }, [idPKNT]);

  //gán chỉ định được họn từ bên ds chỉ định qua
  useEffect(() => {
    // if (dataSource) {
    //   const newData = dataSource?.find((data) => {
    //     listAssign?.dsChiDinh?.find((e) => {
    //       if (e.id === data.id) {
    //         return {
    //           ...e,
    //           soLuong: Number(data.soLuong) + 1,
    //         };
    //       }
    //     });
    //   });
    //   setDataSource([...dataSource, newData]);
    // } else setDataSource(listAssign?.dsChiDinh);
    setDataSource(
      listAssign.dsChiDinh.map((e) => ({
        ...e,
        soLuong: String(e.soLuong),
      }))
    );
  }, [listAssign]);

  columnsSpecifyList.find((e) => {
    if (e.dataIndex === "ghiChu") {
      e.render = (v, r: any, i) => (
        <Form>
          <Form.Item
            name={"ghiChu"}
            rules={[{ required: true, message: "Chưa nhập ghi chú" }]}
          >
            <AutoComplete
              style={{ width: "100%" }}
              options={[
                {
                  value: "Mắt trái",
                  label: "Mắt trái",
                },
                {
                  value: "Mắt phải",
                  label: "Mắt phải",
                },
                {
                  value: "1 Mắt",
                  label: "1 Mắt",
                },
                {
                  value: "2 Mắt",
                  label: "2 Mắt",
                },
                {
                  value: "Lần",
                  label: "Lần",
                },
              ]}
              onChange={(e) => handleGhiChu(e, r.id)}
            />
          </Form.Item>
        </Form>
      );
    } else if (e.dataIndex === "soLuong") {
      e.render = (v, r: any, i) => {
        return (
          <Input
            value={v}
            onChange={(e) => handleSoLuong(e.target.value, r.id)}
          />
        );
      };
    }
  });
  const handleGhiChu = (v, i) => {
    const positionValue = listAssign.dsChiDinh.map((e) => {
      if (e.id === i) {
        return {
          ...e,
          ghiChu: v,
        };
      }
      return e;
    });
    // setDataSource(positionValue);
    dispatch(setListAssign(positionValue));
  };
  const handleSoLuong = (v, i) => {
    if (isNaN(v) || parseInt(v) < 0) {
      // Nếu không hợp lệ, không cập nhật giá trị
      return;
    } else {
      const positionValue = listAssign.dsChiDinh.map((e) => {
        if (e.id === i) {
          return {
            ...e,
            soLuong: v,
          };
        }
        return e;
      });
      // setDataSource(positionValue);
      dispatch(setListAssign(positionValue));
    }
  };
  const day = dayjs().format(FORMAT_TIME.timeDetail);
  const ngayTao = dayjs(dataPhieu?.ngayTao).format(FORMAT_TIME.timeDetail);
  const trangThaiKBNT = dataPhieu?.trangThai;
  const [disable, setDisable] = useState(false);
  useEffect(() => {
    const isDisabled =
      dayjs(ngayTao).isBefore(day, "day") && trangThaiKBNT === 3;
    setDisable(isDisabled);
  }, [day, ngayTao, trangThaiKBNT]);
  return (
    <div className="specify-list-container">
      <div className="container">
        <Space direction="vertical" style={{ width: "100%" }} size={16}>
          <Row justify={"space-between"} align={"middle"}>
            <Col>
              <Row>
                <Typography.Text className="text-title">
                  Danh sách chỉ định trong phiếu hiện tại
                </Typography.Text>
              </Row>
            </Col>
            <Col>
              <Space>
                <Button
                  className="btn-sub"
                  icon={<Icons.printer />}
                  onClick={onValidNote}
                  disabled={disable}
                >
                  Lưu phiếu chỉ định
                </Button>

                <Button
                  className="btn-sub"
                  icon={<Icons.printer />}
                  onClick={onInPCD}
                >
                  In phiếu chỉ định
                </Button>
              </Space>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Table
                dataSource={dataSource}
                // setData={setDataSource}
                columns={columnsSpecifyList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                }}
                bordered
              />
            </Col>
          </Row>
          <Divider></Divider>
          <Row>
            <Col>
              <Typography.Text className="text-title">
                Danh sách chỉ định đã kê trong phiếu khám
              </Typography.Text>
            </Col>
            <Col>
              {/* <Space>
                  <Button icon={<Icons.copy />}>Copy CĐ</Button>
                  <Button icon={<Icons.}
                </Space> */}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Table
                rowKey={(record) => record.id}
                dataSource={actionData.filter(
                  (el) => el?.nhomChiDinhDtos?.length > 0
                )}
                bordered
                columns={columnsSpecifyList2}
                pagination={paginationConfigList}
                onRow={(record) => ({
                  ...rowProps(record),
                })}
                rowSelection={{
                  type: "radio",
                  onChange: onChangeCDRow,
                }}
              />
            </Col>
          </Row>
        </Space>
      </div>
      <ModalSpecify ref={cDRef} />
      <PhieuChiDinh ref={pCDRef} />
      <PhieuChiDinh2 ref={pCDRef2} />
      {/* Cảnh báo k nhập ghi chú */}
      <ModalCustom
        maskClosable={false}
        title="Cảnh báo chưa nhập ghi chú"
        ref={refModal}
        width={500}
      >
        <AlertModal
          message={
            "Chưa nhập ghi chú! Bạn có muốn lưu chỉ định mà chưa có ghi chú?"
          }
        >
          <Row justify={"end"} gutter={16}>
            <Col>
              <Button
                className="btn-sub"
                onClick={() => {
                  onSavePCD();
                  refModal.current.closeModal();
                }}
                type="text"
              >
                Xác nhận
              </Button>
            </Col>
            <Button
              onClick={() => {
                refModal.current.closeModal();
              }}
              danger
            >
              Thoát
            </Button>
          </Row>
        </AlertModal>
      </ModalCustom>
    </div>
  );
});
